<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Nagorik Game</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <h3>{{game.game_name}}
          </h3>
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol sm="6">
          <CSelect
            label="Feature Status"
            :options="[{value:0,label:'OFF'},{value:1,label:'ON'}]"
            :value.sync="game.is_feature"
          />
        </CCol>
        <CCol sm="6" style="display: inline-grid">
          <label>Card Image
          </label>
          <img :src="game.card_img_url" style="width: 200px; height: 200px" />
          <CInputFile
              label="Image thumbnail"
              vertical
              ref="file"
              type="file"
              id="file"
              @change="onImageChange('card_img',$event)"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <!--          <label class="text-danger"-->
          <!--            >(Image Size should be (360 X 360) and less than 1 MB)</label-->
          <!--          >-->
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="6" style="display: inline-grid">
          <span>Profile Image
          </span>
          <img :src="game.profile_img_url" style="width: 200px; height: 200px" />
          <CInputFile
              label="Image thumbnail"
              vertical
              ref="file"
              type="file"
              id="file"
              @change="onImageChange('profile_image',$event)"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
<!--          <label class="text-danger"-->
<!--          >(Image Size should be (360 X 360) and less than 1 MB)</label-->
<!--          >-->
        </CCol>
        <CCol sm="6" style="display: inline-grid">
          <span>Cover Image
          </span>
          <img :src="game.cover_img_url" style="width: 200px; height: 200px" />
          <CInputFile
              label="Image thumbnail"
              vertical
              ref="file"
              type="file"
              id="file"
              @change="onImageChange('cover_image',$event)"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
<!--          <label class="text-danger"-->
<!--          >(Image Size should be (360 X 360) and less than 1 MB)</label-->
<!--          >-->
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"
        ><CIcon name="cil-check-circle" /> Update</CButton
      >
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
// const ROOT_URL = process.env.VUE_APP_ROOT_URL;

export default {
  name: "NagorikGameEdit",
  data() {
    return {
      game: {},
      profile_img_url: "",
      cover_img_url: "",
      card_img_url: "",
      changed_image_names:[]
    };
  },
  created() {
    this.getNagorikGame();
  },
  methods: {
    getNagorikGame() {
      this.$axios
        .get(`${ADMIN_URL}/nagorik-games/${this.$route.params.id}`)
        .then((response) => {
          this.game = response.data.nagorik_game;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(img_type,e) {
      console.log('image_type',img_type)
      console.log('event',e)
      const file = e[0];
      if (file === undefined) {
        return;
      }
      switch(img_type) {
        case "profile_image":
          console.log('dhukse');
          this.game.profile_image = file;
          this.profile_img_url = URL.createObjectURL(file);
          this.changed_image_names.push(img_type)
          break;
        case "cover_image":
          this.game.cover_image = file;
          this.cover_img_url = URL.createObjectURL(file);
          this.changed_image_names.push(img_type)
          break;
        case "card_img":
          this.game.card_img = file;
          this.card_img_url = URL.createObjectURL(file);
          this.changed_image_names.push(img_type)
          break;
        default:
          break;
      }
      console.log('profile',this.game.profile_image)
      console.log('cover',this.game.cover_image)
      console.log('card',this.game.card_img)
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("is_feature", this.game.is_feature);
      formData.append("profile_image", this.game.profile_image);
      formData.append("cover_image", this.game.cover_image);
      formData.append("card_img", this.game.card_img);
      formData.append("changed_images", JSON.stringify(this.changed_image_names));
      formData.append("_method", "PUT");


      this.$axios
        .post(`${ADMIN_URL}/nagorik-games/${this.$route.params.id}`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
          this.$router.go(0)
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal(
            "Error",
            JSON.stringify(error.response.data.message),
            "error"
          );
        });
    },
  },
};
</script>

<style scoped>
</style>
